import { useInfiniteTags } from '@ukpostbox/client-data';
import {
	ComboBoxControl,
	ComboBoxItemDisplayEnum,
	ComboBoxTypeEnum,
	SelectItemType,
} from '@ukpostbox/frontend-framework';
import { useFormContext } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { useEffect, useState } from 'react';

type HasLabelConditionType = {
	name: string;
	defaultValue: any;
	changeCallback: (value: any) => void;
};

function HasTagCondition(props: HasLabelConditionType) {
	const { setValue } = useFormContext();

	const { data, status } = useInfiniteTags();
	const [tagOptions, setTagOptions] = useState<Array<SelectItemType>>([]);

	const IterateData = () => {
		const NewTagOptions: Array<SelectItemType> = [];

		data?.pages.forEach(
			(page) =>
				page?.data &&
				page.data.filter((tag, index: number) =>
					tag ? NewTagOptions.push({ label: tag.name, value: tag.id }) : null,
				),
		);

		setTagOptions(NewTagOptions);
	};

	useEffect(() => {
		if (data) {
			IterateData();
		}
	}, [data]);

	return (
		<ComboBoxControl
			name={props.name}
			placeholder='Select Tag...'
			data={tagOptions}
			defaultValue={props.defaultValue ? [props.defaultValue] : undefined}
			loading={status === 'pending'}
			disabled={status === 'error'}
			valueType='number'
			displayType={ComboBoxTypeEnum.Multi}
			displayItemLabelType={ComboBoxItemDisplayEnum.Label}
			forwardValuesCallback={(val) => {
				setValue(props.name, val);
			}}
		/>
	);
}

export { HasTagCondition };
